import _ from 'lodash';
import axios from 'axios';
import Point from '@/js/core/classes/Point';
import Vue from 'vue';
import { format } from 'util';

axios.defaults.withCredentials = true;

const client = axios.create({
  baseURL: DEBUG ? '/api' : '/'
});

client.interceptors.response.use(response => {
  // console.log(response);
  let httpStatus = _.get(response, 'status');
  let responseStatus = _.get(response, 'data.status');
  if (httpStatus == 401 || responseStatus == 401 && !~['/login', '/login/'].indexOf(window.location.pathname)) {
    // window.location.href = '/login';
  }
  return response;
}, error => {
  return Promise.reject(error);
});

export default {
  getLatestNews() {
    return client.get('/last_news/')
  },
  getOrder(data) {
    return client.post('files/', data);
  },
  getTrackOrder(data) {
    return client.post('tracking/', data);
  },
  uploudFileUrl: client.prototype.constructor.defaults.baseURL + 'loadFile/',
  deleteFile(id) {
    return client.post('deleteFile/', {
      uid: id
    });
  },
  feedbackForm(data) {
    return client.post('feedbackForm/', data);
  },
  getDocTypes() {
    return client.get('getDocsCategory/')
  },
  getDocList(data) {
    return client.post(`getDocs/`, data)
  },
  getDocCategory(data) {
    return client.get(`getDocsCategory/${data}/`)
  },
  getInstrTypes() {
    return client.get('getInstr/')
  },
  getInstrList(data) {
    return client.post('getInstr/', data)
  },
  getInstrCategory(data) {
    return client.get(`getInstrCategory/${data}/`)
  },
  towns() {
    return client.get('getTowns/');
  },
  cargoKinds() {
    return client.get('getCargoKinds/');
  },
  docTypes() {
    return client.get('getDocTypes/');
  },
  defaultCalc() {
    return client.get('calc/');
  },
  calculate(data) {
    return client.post('calc/', data);
  },
  createOrder(data) {
    return client.post('createOrder/', data);
  },
  getOrderRequestBody(id) {
    return client.get(`orderRequestBody/?order_id=${id}`)
  },
  getMap() {
    return new Promise((resolve, reject) => {
      client.get('map/').then(res => {
        resolve(res.data.map(item => new Point(item)))
      }, rej => {
        reject(rej)
      })
    })
  },
  // GET /map/:id
  getMapById(id) {
    return new Promise((resolve, reject) => {
      if (!id) reject('Нет id')
      client.post('map/', {
        id: id
      }).then(res => {
        resolve(new Point({
          FSName: res.data.filial_name,
          TownName: res.data.town_name,
          FSID: res.data.filial_id,
          AreaName: res.data.area_name,
          TownID: res.data.town_id,
          isFilial: res.data.is_filial,
          area_items: res.data.area_items,
          PossibleToSendTermo: res.data.is_to_send_termo,
          FSTermo: res.data.is_termo
        }))
      }, rej => {
        reject(rej)
      })
    })
  },
  vacancy: {
    category: {
      list() {
        return client.get('getCategoryVacancy/');
        // return new Promise((resolve, reject) => {
        //   resolve({
        //     data: [{"name": "Административный персонал", "id": 1}, {"name": "Транспорт, логистика", "id": 3}]
        //   })
        // })
      },
      get(id) {
        return client.get('getCategoryVacancy/' + id + '/');
        // return new Promise((resolve, reject) => {
        //   resolve({
        //     data: {"name": "Административный персонал", "id": 1, "countVacancy": 2}
        //   })
        // })
      }
    },
    content: {
      list(id) {
        return client.post('getVacancy/', {
          id: +id
        });
        // let data = {
        //   1: [{"wage": "до 40 000 руб. на руки", "conditions": "Оформление по ТК РФ; |График работы с 10:00 до 19:00; |З/п: оклад + премия (доход до 40000 руб на руки); |На период обучения и адаптации вас будет сопровождать опытный наставник; |Возможность профессионально обучаться и продвигаться по карьерной лестнице.", "requirements": "Уверенный пользователь ПК; |Умение работать в режиме многозадачности; |Знание делового телефонного этикета; |Пунктуальность, внимательность, ответственность, исполнительность.", "id": 4, "is_active": true, "name": "Оператор ввода данных/ оператор call-центра", "create_date": "2019-05-21", "responsibility": "Прием входящих звонков от клиентов; |Консультирование клиентов о правилах работы и видах предоставляемых услуг; |Предварительный расчет стоимости транспортно-экспедиционных услуг; |Оформление и ведение заявок клиентов, выставление счетов, работа с документами; |Оповещение клиентов по заявкам (исходящие звонки); |Заполнение статистики звонков, отчетности; |Работа с онлайн-консультантом..", "city_name": "Орел", "category_id": 1, "schedule": "с 10:00 до 19:00"}, {"wage": "До 40 000", "conditions": "Условия|Условия|Условия", "requirements": "Требования|Требования|Требования", "id": 2, "is_active": true, "name": "Оператор ввода данных/ оператор call-центра", "create_date": "2019-05-21", "responsibility": "Обязаности|Обязаности|Обязаности", "city_name": "Москва", "category_id": 1, "schedule": "Полный рабочий день"}, {"wage": "До 40 000", "conditions": "Условие1|Условие2|Условие3", "requirements": "Требование1|Требование2|Требование3", "id": 1, "is_active": true, "name": "Менеджер по продажам услуг грузоперевозок", "create_date": "2019-05-21", "responsibility": "Обязанность1|Обязанность2|Обязанность3", "city_name": "Москва", "category_id": 1, "schedule": "Полный рабочий день"}],
        //   3: [{"wage": "сдельная (доход от 50000 руб до 120000 рублей на руки)", "conditions": "Официальное оформление по ТК РФ + соц. пакет; |Территориально: Варшавское шоссе, вл 248; |Стабильная выплата з/п (два раза в месяц)", "requirements": "Опыт работы более 6 лет; |Наличие водительского удостоверения категории \"В.С.Е\"; |Водительский стаж от 5-х лет на грузовых автомобилях (стаж должен быть подтвержден документально); |Опыт работы по грузоперевозкам; |Водительские права категории E.", "id": 3, "is_active": true, "name": "Водитель-экспедитор (категория В,С,Е)", "create_date": "2019-05-21", "responsibility": "Качественная и своевременная доставка грузов по Москве, МО, городам спутникам и по всей России; |Экспедирование грузов; |Оформление сопроводительной документации; |Текущее техническое обслуживание а/м.", "city_name": "Москва", "category_id": 3, "schedule": "Полная занятость, Вахтовый метод"}]
        // }
        // return new Promise((resolve, reject) => {
        //   resolve({
        //     data: data[id]
        //   })
        // })
      },
      get(id) {
        return client.get('getVacancy/' + id + '/');
        // return new Promise((resolve, reject) => {
        //   resolve({
        //     data: {"wage": "сдельная (доход от 50000 руб до 120000 рублей на руки)", "conditions": "Официальное оформление по ТК РФ + соц. пакет; |Территориально: Варшавское шоссе, вл 248; |Стабильная выплата з/п (два раза в месяц)", "requirements": "Опыт работы более 6 лет; |Наличие водительского удостоверения категории \"В.С.Е\"; |Водительский стаж от 5-х лет на грузовых автомобилях (стаж должен быть подтвержден документально); |Опыт работы по грузоперевозкам; |Водительские права категории E.", "id": 3, "is_active": true, "name": "Водитель-экспедитор (категория В,С,Е)", "create_date": "2019-05-21", "responsibility": "Качественная и своевременная доставка грузов по Москве, МО, городам спутникам и по всей России; |Экспедирование грузов; |Оформление сопроводительной документации; |Текущее техническое обслуживание а/м.", "city_name": "Москва", "category_id": 3, "schedule": "Полная занятость, Вахтовый метод"}
        //   })
        // })
      }
    }
  },
  vacancyForm(data) {
    return client.post('vacancyResponse/', data);
  },
  registerUser(data) {
    return client.post('signup/', data);
  },
  login(data) {
    return client.post('signin/', data);
  },
  logout() {
    return client.post('logout/');
  },
  resetPassword(data) {
    return client.post('reset_password/', data);
  },
  checkResetConfirmToken(userid, tokenid) {
    return client.post(`reset-confirm/${userid}/${tokenid}/`);
  },
  resetConfirm(userid, tokenid, data) {
    return client.put(`reset-confirm/${userid}/${tokenid}/`, data);
  },
  getOrders(page, filters, perPage) {
    return client.get('getOrders/', {
      params: _.extend({
        perPage,
        page: page
      }, filters)
    });
  },
  cancelOrder(OrderNo) {
    return client.post('cancelOrder/', { OrderNo })
  },
  getOrdersArchive(files) {
    return client.post('getOrdersArchive/', {
      files: files
    })
  },
  getOrder(no) {
    return client.post('getOrders/', {
      OrderNo: no
    });
  },
  getOrdersDics() {
    return client.get('getOrdersDict/');
  },
  createReport(filters, fields, groupBy) {
    let params = {};
    if (fields && fields.length) {
      _.extend(params, {fields: fields.join(',')})
    }
    if (groupBy && groupBy.length) {
      _.extend(params, {groupBy: groupBy.join(',')})
    }
    return client.get('createReport/', {
      params: _.extend(params, filters)
    })
  },
  getProfile() {
    return client.get('getProfile/');
  },
  changeProfile(data) {
    return client.post('changeProfile/', data);
  },
  changePassword(data) {
    return client.post('changePassword/', data);
  },
  getPayers(page, perPage) {
    return client.get('getPayers/', {
      params: {
        page,
        perPage
      }
    });
  },
  getPayer(id) {
    return client.post('getPayers/', {"AgentID": Number(id)});
  },
  updatePayerContacts(data) {
    return client.post('updatePayerContacts/', data);
  },
  createPayer(data) {
    return client.post('createPayer/', data);
  },
  inviteUser(data) {
    return client.post('inviteUser/', data);
  },
  getInvites() {
    return client.get('getInvites/');
  },
  cancelInvite(data) {
    return client.post('cancelInvite/', data);
  },
  getInviteRights() {
    return client.get('inviteRights/');
  },
  saveInviteRights(data) {
    return client.post('inviteRights/', data);
  },
  saveCalc(data) {
    return client.put('calc/', data);
  },
  getCalcList(page, perPage) {
    return client.get('getCalcList/', {
      params: {
        page,
        perPage
      }
    });
  },
  deleteCalc(id) {
    return client.post('deleteCalc/', {calc_id: id});
  },
  getCalc(id) {
    return client.post('getCalc/', {calc_id: Number(id)});
  },
  checkSignupConfirmToken(tokenid) {
    return client.post(`signup-confirm/${tokenid}/`);
  },
  checkSigninConfirmToken(tokenid) {
    return client.post(`signin-confirm/${tokenid}/`);
  },
  getUserAgents() {
    return client.get('getUserAgents/');
  },
  getUserAgentsByTown(from, to) {
    return client.post('getUserAgents/', {
      city_from_id: from,
      city_to_id: to
    });
  },
  setDefaultPayer(id) {
    return client.post('setDefaultPayer/', {
      payer_id: id
    })
  },
  getCalcPrintForm(calc_fields, cargo_fields, calc_response, agents) {
    return client.post('loadCalcPDF/', {
      calc_fields: calc_fields,
      cargo_fields: cargo_fields,
      calc_response: calc_response,
      agents: agents
    }, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    })
  }
}
